import React, { ReactNode } from 'react';
import { useAuth } from '../../context/AuthContext';
import AccessDenied from './AccessDenied';

interface AdminGuardProps {
  children: ReactNode;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { isAdmin } = useAuth();

  // Show access denied if user is not an admin
  if (!isAdmin()) {
    return <AccessDenied />;
  }

  // Render protected admin content if user is an admin
  return <>{children}</>;
};

export default AdminGuard;
